import React from 'react'

const requiredOatsInputs = {
  stringOnly: new Set<string>(['Köpare']),
  numbersOnly: new Set<string>(['Bruttopris', 'Summa kr. totalt', 'Nettovikt']),
  dateOnly: new Set<string>(['Lev. datum']),
}

const requiredEggsInputs = {
  stringOnly: new Set<string>(['Packeri']),
  numbersOnly: new Set<string>(['Vecka']),
  dateOnly: new Set<string>(['Avräkningsdatum']),
}

const requiredRapsInputs = {
  stringOnly: new Set<string>(['Köpare']),
  numbersOnly: new Set<string>(['Avräkningspris', 'Invägd vikt ton', 'Korrigerad delsumma']),
  dateOnly: new Set<string>(['Lev. datum']),
}

const requiredFoderInputs = {
  stringOnly: new Set<string>(['Säljare']),
  numbersOnly: new Set<string>(['Kvantitet', 'Momsgrund', 'Kundnummer', 'Foder Konstant']),
  dateOnly: new Set<string>(['Fakturadatum']),
}

export function getLabelAndInputElements(parentDivList: HTMLCollection): HTMLElement[][] {
  const labelElements: HTMLLabelElement[] = []
  const inputElements: HTMLInputElement[] = []
  const labelAndInputElements: HTMLElement[][] = []
  for (let i = 0; i < parentDivList.length - 3; i++) {
    const div = parentDivList[i]
    const inputElement = div.children[2] as HTMLInputElement
    const labelElement = div.children[1] as HTMLLabelElement
    labelElements.push(labelElement)
    inputElements.push(inputElement)
  }

  labelAndInputElements.push(labelElements)
  labelAndInputElements.push(inputElements)

  return labelAndInputElements
}

export function validateInput(
  labelElements: HTMLLabelElement[],
  inputElements: HTMLInputElement[],
  product: string,
): boolean {
  let isValid = false
  for (let i = 0; i < labelElements.length; i++) {
    const label = labelElements[i]
    const input = inputElements[i]

    if (product === 'oats') {
      if (requiredOatsInputs.stringOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'text')
      } else if (requiredOatsInputs.numbersOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'number')
      } else if (requiredOatsInputs.dateOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'date')
      }
    }
    if (product === 'eggs') {
      if (requiredEggsInputs.stringOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'text')
      } else if (requiredEggsInputs.numbersOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'number')
      } else if (requiredEggsInputs.dateOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'date')
      }
    }
    if (product === 'raps') {
      if (requiredRapsInputs.stringOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'text')
      } else if (requiredRapsInputs.numbersOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'number')
      } else if (requiredRapsInputs.dateOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'date')
      }
    }
    if (product === 'foder') {
      if (requiredFoderInputs.stringOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'text')
      } else if (requiredFoderInputs.numbersOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'number')
      } else if (requiredFoderInputs.dateOnly.has(label.textContent ?? '')) {
        isValid = validateType(input.value, input, 'date')
      }
    }
  }

  return isValid
}

export function validateType(
  inputValue: string,
  inputField: HTMLInputElement,
  typeCheck: string,
): boolean {
  let type
  if (typeCheck === 'number') {
    type = new RegExp('^[0-9.,]+$')
  } else if (typeCheck === 'text') {
    type = new RegExp('^[a-zA-ZäöåÄÖÅ _]*$')
  }

  if (inputValue === '') {
    inputField.setCustomValidity('Fältet får inte vara tomt')
    inputField.reportValidity()
    return false
  }
  if (typeCheck !== 'date' && !type.test(inputValue)) {
    if (typeCheck === 'text') inputField.setCustomValidity('Ange endast bokstäver')
    if (typeCheck === 'number') inputField.setCustomValidity('Ange endast siffror')
    inputField.reportValidity()
    return false
  }

  inputField.setCustomValidity('')
  inputField.reportValidity()

  return true
}
